import camelCase from 'lodash/camelCase'

// Auto Import any js file in the resources directory
const requireModule = require.context('./resources', false, /[\w]+\.js/) // Extract js files inside modules folder
const modules = {}

requireModule.keys().forEach(fileName => {
  if (fileName === './index.js') return // Reject the index.js file

  const moduleName = camelCase(fileName.replace(/(\.\/|\.js)/g, ''))

  modules[moduleName] = requireModule(fileName).default
})

export default modules

/**
 * '/hello/world'     -> 'hello/world'
 * 'hello/world/'     -> 'hello/world'
 * '/hello/world/'    -> 'hello/world'
 * '//hello/world///' -> 'hello/world'
 */
const trimSlashes = str => str.replace(/^\/+|\/+$/g, '')

/**
 * Trimming any slashes to prevent user error of adding unnecessary slashes in the URLs
 * So, we TRIM (only from the ends) all the slashes and add the corrent number of slashes in the function
 */
export function resourceConstructor(resource) {
  return url => `/${resource}/${trimSlashes(url)}${url && '/'}`
}

// Why is this not working I have no idea
// export const resourceConstructor = resource => url =>
//   `/${resource}/${trimSlashes(url)}/`
